const moduleMap = {
    actions: import.meta.glob('./actions/*.(mjs|jsx)', {eager: true}),
    commands: import.meta.glob('./commands/*.(mjs|jsx)', {eager: true}),
}

export default () => {
    const extensions = map => ({
        ...Object.fromEntries(
            Object.entries(moduleMap).map(([key, modules]) => [
                key,

                Object.fromEntries(
                    Object.values(modules)
                        .map(
                            module => Object.entries(module).map(
                                ([name, fn]) => [name, fn.bind(map)]
                            )
                        )
                        .flat()
                )
            ])
        ),
    })

    return {extensions}
}
